import { SxProps, Theme } from "@mui/material/styles";

export const styles: Record<string, SxProps<Theme>> = {
  tab: {
    p: "4px 16px",
    "&.Mui-selected": { color: "grey900" },
  },
};
